import { render, staticRenderFns } from "./SkillsRead.vue?vue&type=template&id=4a4d04c2&scoped=true"
import script from "./SkillsRead.vue?vue&type=script&lang=js"
export * from "./SkillsRead.vue?vue&type=script&lang=js"
import style0 from "./SkillsRead.vue?vue&type=style&index=0&id=4a4d04c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d04c2",
  null
  
)

export default component.exports